// extracted by mini-css-extract-plugin
export default {"publication":"publication_publication__MwBcE","post":"publication_post__LWIQ1"};